import { api } from '../config/api';

export interface DashboardStats {
  totalAgendamentos: number;
  agendamentosHoje: number;
  agendamentosPendentes: number;
  cargasEmAndamento: number;
  cargasFinalizadas7d: number;
  usuariosAtivos: number;
  filiaisAtivas: number;
  visitasHoje: number;
  visitasPendentes: number;
  solicitacoesAprovadas: number;
}

export interface AgendamentosPorStatus {
  [status: string]: number;
}

export interface AgendamentosPorFilial {
  filial: string;
  total: number;
  pendentes: number;
  aprovados: number;
}

export interface AtividadeRecente {
  id: string;
  usuario_id: string;
  usuario_nome: string;
  usuario_login: string;
  acao: string;
  modulo: string;
  descricao: string;
  dados_anteriores?: any;
  dados_novos?: any;
  ip_address: string;
  user_agent: string;
  data_acao: string;
  filial_atual?: string;
}

class DashboardServiceAPI {
  // Buscar estatísticas gerais do dashboard
  static async buscarStats(): Promise<DashboardStats> {
    try {
      const response = await api.get('/dashboard/stats');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar estatísticas do dashboard:', error);
      throw error;
    }
  }

  // Buscar agendamentos por status
  static async buscarAgendamentosPorStatus(): Promise<AgendamentosPorStatus> {
    try {
      const response = await api.get('/dashboard/agendamentos-por-status');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar agendamentos por status:', error);
      throw error;
    }
  }

  // Buscar agendamentos por filial
  static async buscarAgendamentosPorFilial(): Promise<AgendamentosPorFilial[]> {
    try {
      const response = await api.get('/dashboard/agendamentos-por-filial');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar agendamentos por filial:', error);
      throw error;
    }
  }

  // Buscar atividades recentes
  static async buscarAtividadesRecentes(): Promise<AtividadeRecente[]> {
    try {
      const response = await api.get('/dashboard/atividades-recentes');
      return response.data || [];
    } catch (error) {
      console.error('Erro ao buscar atividades recentes:', error);
      throw error;
    }
  }

  // Buscar dados completos do dashboard
  static async buscarDadosCompletos(): Promise<{
    stats: DashboardStats;
    agendamentosPorStatus: AgendamentosPorStatus;
    agendamentosPorFilial: AgendamentosPorFilial[];
    atividadesRecentes: AtividadeRecente[];
  }> {
    try {
      const [stats, agendamentosPorStatus, agendamentosPorFilial, atividadesRecentes] = await Promise.all([
        this.buscarStats(),
        this.buscarAgendamentosPorStatus(),
        this.buscarAgendamentosPorFilial(),
        this.buscarAtividadesRecentes()
      ]);

      return {
        stats,
        agendamentosPorStatus,
        agendamentosPorFilial,
        atividadesRecentes
      };
    } catch (error) {
      console.error('Erro ao buscar dados completos do dashboard:', error);
      throw error;
    }
  }

  // Buscar estatísticas por período
  static async buscarStatsPorPeriodo(dataInicio: string, dataFim: string): Promise<DashboardStats> {
    try {
      const response = await api.get(`/dashboard/stats?dataInicio=${dataInicio}&dataFim=${dataFim}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar estatísticas por período:', error);
      throw error;
    }
  }

  // Buscar métricas de performance
  static async buscarMetricasPerformance(): Promise<{
    tempoMedioAtendimento: number;
    taxaConversao: number;
    satisfacao: number;
  }> {
    try {
      // Simulação - implementar lógica real quando necessário
      return {
        tempoMedioAtendimento: 15.5,
        taxaConversao: 78.3,
        satisfacao: 4.2
      };
    } catch (error) {
      console.error('Erro ao buscar métricas de performance:', error);
      throw error;
    }
  }
}

export default DashboardServiceAPI;
